import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const LooksSection = () => {
  const looks = [
    {
      id: 1,
      title: "Oficina Elegante",
      description: "Sofisticación profesional",
      image: "https://images.unsplash.com/photo-1588186941799-f9a4fc54ff1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd29tYW4lMjBmYXNoaW9uJTIwbW9kZWwlMjBvZmZpY2UlMjBzdHlsZSUyMGJsYXplcnxlbnwwfHx8fDE3NzM0MDA3MTJ8MA&ixlib=rb-4.1.0&q=85",
      link: "https://styleoutlet.es/11-abrigos-chaquetas-trucco"
    },
    {
      id: 2,
      title: "Casual Chic",
      description: "Comodidad con estilo urbano",
      image: "https://images.unsplash.com/photo-1729808785139-c8de8eff75d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGNhc3VhbCUyMGNoaWMlMjBzdHJlZXQlMjBzdHlsZSUyMGJlaWdlJTIwY29hdHxlbnwwfHx8fDE3NzM0MDA3MTN8MA&ixlib=rb-4.1.0&q=85",
      link: "https://styleoutlet.es/14-punto-trucco"
    },
    {
      id: 3,
      title: "Cena o Evento",
      description: "Brilla en ocasiones especiales",
      image: "https://images.unsplash.com/photo-1768508947982-de0fe8d0792b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd29tYW4lMjBldmVuaW5nJTIwZHJlc3MlMjBkaW5uZXIlMjBldmVudHxlbnwwfHx8fDE3NzM0MDA3MTN8MA&ixlib=rb-4.1.0&q=85",
      link: "https://styleoutlet.es/12-vestidos-trucco"
    }
  ];

  return (
    <section data-testid="looks-section" className="section-padding bg-[#EDE7E1]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-sans tracking-[0.2em] uppercase text-[#C8A96A] mb-4 block">
            Inspiración
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#111111] mb-4">
            Inspiración de looks
          </h2>
          <p className="text-lg font-sans text-[#111111]/70">
            Encuentra la combinación perfecta para cada momento
          </p>
        </div>

        {/* Looks Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
          {looks.map((look) => (
            <a
              key={look.id}
              href={look.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`look-card-${look.id}`}
              className="group relative overflow-hidden aspect-[3/4] cursor-pointer"
            >
              {/* Image */}
              <img
                src={look.image}
                alt={look.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 look-gradient" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="inline-block bg-[#C8A96A] text-white text-xs font-bold tracking-wider uppercase px-3 py-1 mb-4">
                    Look {look.id}
                  </span>
                  <h3 className="font-serif text-2xl md:text-3xl text-white mb-2">
                    {look.title}
                  </h3>
                  <p className="font-sans text-white/80 mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    {look.description}
                  </p>
                  <span className="inline-flex items-center text-white font-bold text-sm tracking-wider uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    Ver productos
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </span>
                </div>
              </div>

              {/* Corner accent */}
              <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-white/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="https://styleoutlet.es/28-top-ventas" 
            target="_blank" 
            rel="noopener noreferrer"
            data-testid="looks-cta"
          >
            <Button className="bg-[#111111] hover:bg-[#C8A96A] text-white px-10 py-6 text-base font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer">
              Inspirarte con nuevos looks
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default LooksSection;
